import { useMemo } from 'react';

import TextFormatter from '@/modules/admin/views/errors/components/Grid/useColumns/TextFormatter';
import { getInfo, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, deleteAction, editAction, duplicateAction, defaultActionsColumn, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Name', info => <NameAndCreateDateFormatter info={info} />, { size: 300 }),
    defaultColumn('slug'),
    defaultColumn('method'),
    column.accessor('url', {
      header: 'URL',
      cell: info => <TextFormatter info={info} value={new URL(getInfo(info)?.value).origin} />,
      enableSorting: false,
      size: 300,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateAction),
  ], [])
}
